(()=>{
  /* studio photos (tall, solid corners) fill the piece card; cut-outs keep their padded frame */
  const cache={};
  const solid=src=>cache[src]||(cache[src]=fetch(src,{mode:'cors'}).then(r=>r.blob()).then(b=>createImageBitmap(b)).then(bmp=>{
    const c=document.createElement('canvas');c.width=bmp.width>200?200:bmp.width;c.height=Math.round(c.width*bmp.height/bmp.width);
    const x=c.getContext('2d',{willReadFrequently:true});x.drawImage(bmp,0,0,c.width,c.height);
    const pts=[[1,1],[c.width-2,1],[1,c.height-2],[c.width-2,c.height-2]];
    return pts.every(p=>x.getImageData(p[0],p[1],1,1).data[3]>=250);
  }).catch(()=>false));
  const mark=img=>{
    const run=()=>{
      const w=img.naturalWidth,h=img.naturalHeight;
      if(!w||!h)return;
      const ratio=h/w;
      if(ratio<1.15||ratio>1.4){img.classList.remove('ef-full');return}
      solid(img.currentSrc||img.src).then(ok=>img.classList.toggle('ef-full',!!ok));
    };
    if(img.complete)run();else img.addEventListener('load',run,{once:true});
  };
  const scan=()=>document.querySelectorAll('.efpv-piece__media img').forEach(mark);
  scan();
  new MutationObserver(scan).observe(document.documentElement,{childList:true,subtree:true});
})();
